var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7028 14.4711C16.2766 11.8738 17.0684 6.87113 14.4711 3.29725C11.8738 -0.276641 6.87113 -1.06835 3.29724 1.52891C-0.27664 4.12617 -1.06835 9.12887 1.52891 12.7028C4.12617 16.2766 9.12887 17.0683 12.7028 14.4711ZM9.33892 7.0268L4.10814 2.6444L6.66123 8.97277L7.42626 8.41679C7.42624 8.41676 7.42629 8.41683 7.42626 8.41679L6.66123 8.97277L11.892 13.3553L9.33892 7.0268L8.57392 7.58291C8.5739 7.58288 8.57395 7.58295 8.57392 7.58291L9.33892 7.0268ZM8.57392 7.58291L7.42626 8.41679C7.65659 8.73356 8.10017 8.80381 8.41702 8.57355C8.73386 8.34328 8.80409 7.8998 8.57392 7.58291ZM8.57392 7.58291L7.42626 8.41679C7.42624 8.41676 7.42629 8.41683 7.42626 8.41679C7.19596 8.0999 7.26613 7.65626 7.58303 7.42596C7.89993 7.19566 8.34362 7.26602 8.57392 7.58291C8.57395 7.58295 8.5739 7.58288 8.57392 7.58291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.26d3a3a4643398e51ee2f6d59abfe622.svg";
export { ForwardRef as ReactComponent };